/* FIELD */
export const isSectionsEmptyField = {
    read(_, { readField }) {
        const sections = readField('sections');
        return !sections?.length;
    },
};
